import { FormApi } from 'final-form'
import React from 'react'
import { ListGroup } from 'react-bootstrap'
import { FieldArray } from 'react-final-form-arrays'

import Button from '../../Button'
import CronTime from './CronTime'

type TCronTimes = {
  name: string
  form: FormApi
  disableSecondChoice: boolean
}

const CronTimes = (props: TCronTimes): React.ReactElement => {
  const { name, form, disableSecondChoice = false } = props

  const { mutators } = form

  const add = (): void => {
    mutators.push(name, null)
  }

  return (
    <div className="my-1">
      <div className="mb-1 form-group">
        <label
          className="form-label"
          style={{ marginBottom: '2px', opacity: 1, position: 'relative' }}
        >
          {i18n.t(`execution_times`, `Ausführungszeiten`)}
        </label>
      </div>

      <ListGroup className="mb-2">
        <FieldArray name={name}>
          {({ fields }) => {
            return fields.length && fields.length > 0 ? (
              fields.map((name, index) => (
                <ListGroup.Item key={index} style={{ paddingBottom: '0' }}>
                  <CronTime
                    key={name}
                    name={name}
                    index={index}
                    onRemove={fields.remove}
                  />
                </ListGroup.Item>
              ))
            ) : (
              <ListGroup.Item variant="light">
                {i18n.t('no_execution_times', 'Keine Ausführungszeiten')}
              </ListGroup.Item>
            )
          }}
        </FieldArray>
      </ListGroup>
      <div>
        <Button
          small
          info
          icon="far fa-plus"
          onClick={add}
          disabled={disableSecondChoice}
        >
          {i18n.t(`add_execution_time`, `Ausführungszeit hinzufügen`)}
        </Button>
      </div>
    </div>
  )
}

export default CronTimes
